import React, { forwardRef } from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  className = '',
  label,
  error,
  helperText,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-1660">
        {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1661">
            {label}
            {props.required && <span className="text-red-500 ml-1" data-id="element-1662">*</span>}
          </label>}
        <textarea ref={ref} className={`w-full rounded-lg border ${error ? 'border-red-500' : 'border-gray-300'} px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-greenback focus:border-transparent disabled:bg-gray-100 disabled:text-gray-500 ${className}`} {...props} data-id="element-1663" />
        {helperText && !error && <p className="mt-1 text-xs text-gray-500" data-id="element-1664">{helperText}</p>}
        {error && <p className="mt-1 text-xs text-red-500" data-id="element-1665">{error}</p>}
      </div>;
});
Textarea.displayName = 'Textarea';